import React, { useState } from 'react';
import { ThumbnailLoading } from '../ThumbnailLoading';
import './Image.css';
import classNames from 'classnames';

export const ImageType = Object.freeze({
    DEFAULT: 'default',
    HORIZONTAL_RECTANGLE: 'horizontalRectangleImage',
    VERTICAL_RECTANGLE: 'verticalRectangleImage',
});

const getImageSrc = (images, imageType) => {
    const jpg = images[imageType] || images.default;
    const webp = imageType === ImageType.DEFAULT ? images.webp : jpg;

    return {
        jpg,
        webp
    };
};

export const Image = ({
    className = '',
    images,
    alt = '',
    loadingIcon = null,
    onClickHandler = null,
    imageType = ImageType.DEFAULT,
}) => {
    const [imgLoadingError, setImgLoadingError] = useState(false);
    const [imgLoadingInProgress, setImgLoadingInProgress] = useState(true);
    const { webp, jpg } = getImageSrc(images, imageType);

    const loadingComponent = <ThumbnailLoading className={className} iconName={loadingIcon} />;

    const pictureClassName = classNames(
        'asg-webp-picture',
        {
            'asg-webp-picture--loading': imgLoadingInProgress,
        }
    );
    const imgClassName = classNames(
        ' asg-webp-picture__img',
        className,
    );

    return <div className="asg-picture-wrap" onClick={onClickHandler}>
        {/*show loader until image load finished or failed to load*/}
        {(imgLoadingInProgress || imgLoadingError) && loadingComponent}

        {!imgLoadingError && <picture className={pictureClassName}>
            {webp && <source
                type="image/webp"
                srcSet={webp}
            />}

            {jpg && <img
                loading="lazy"
                src={jpg}
                className={imgClassName}
                alt={alt}
                onLoad={() => {
                    setImgLoadingInProgress(false);
                }}
                onError={({ currentTarget }) => {
                    currentTarget.onerror = null;
                    setImgLoadingError(true);
                }}
            />}
        </picture>}
    </div>;
};
